import React from 'react';
import * as AlertDialog from '@radix-ui/react-alert-dialog';
import XIcon from './common/svg/XIcon';
import { GhostButton, MutateForSpecialBackgroundButton } from './button/Button';
import { WarningBox } from './common/StatusBox';
import classNames from 'classnames';

export default function WarningAlertDialog({
  open,
  onOpenChange,
  onAction,
  actionLabel,
  onEscapeKeyDown,
  className,
  children,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAction: (e: React.MouseEvent) => void;
  actionLabel: string;
  onEscapeKeyDown?: (e: KeyboardEvent) => void;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="DialogOverlay">
          <div className="flex" onClick={(e) => e.stopPropagation()}>
            <AlertDialog.Content
              asChild
              className={classNames('WarningAlertDialogContent p-6 rounded-2xl', className)}
              onEscapeKeyDown={onEscapeKeyDown}
              onOpenAutoFocus={(e) => e.preventDefault()}
            >
              <WarningBox>
                <AlertDialog.Cancel asChild>
                  <button className="btn btn-sm btn-circle btn-ghost focus:bg-amber-500/50 hover:bg-amber-500/50 focus:border-black hover:border-black absolute right-2 top-2">
                    <XIcon />
                  </button>
                </AlertDialog.Cancel>
                <div className="relative flex flex-col gap-4">
                  {children}
                  <div className="modal-action mt-0">
                    <AlertDialog.Cancel asChild>
                      <GhostButton className="btn-outline focus:bg-amber-500/50 hover:bg-amber-500/50 focus:border-black hover:border-black">
                        Cancel
                      </GhostButton>
                    </AlertDialog.Cancel>
                    <AlertDialog.Action asChild>
                      <MutateForSpecialBackgroundButton onClick={onAction}>
                        {actionLabel}
                      </MutateForSpecialBackgroundButton>
                    </AlertDialog.Action>
                  </div>
                </div>
              </WarningBox>
            </AlertDialog.Content>
          </div>
        </AlertDialog.Overlay>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
}
